<template>
    <p class="mb-0 text-muted text-center fs-80"><i class="fa fa-circle-notch fa-spin"></i> Caricamento in corso...</p>
</template>
<script>
export default {
    
}
</script>